import React from 'react';
import { FiStar } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const testimonials = [
  {
    text: "The 'I'm fine' translation saved my marriage. I was about to file for divorce over 'nothing.' Turns out we were just lost in translation. We're in therapy now, but this book gave us the language to even start.",
    author: "Jennifer, 34",
    role: "Married 7 years"
  },
  {
    text: "I bought this on impulse. Figured it was $10, whatever. Used the 'I'm tired' translation with my wife that night. She cried. Said 'You finally get it.' Best $10 I ever spent.",
    author: "Marcus, 41",
    role: "Verified Buyer"
  },
  {
    text: "As a therapist, I recommend this to couples who need immediate help. The translations are psychologically sound and immediately usable. It's like having me in their pocket.",
    author: "Dr. Sarah Chen",
    role: "Licensed MFT"
  }
];

const Testimonials = () => {
  return (
    <section className="py-20 bg-brand-black">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-16 text-center">
          500+ Readers Stopped Guessing and <span className="text-brand-yellow">Started Understanding</span>
        </h2>
        
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-brand-gray p-8 rounded-xl border border-white/5 relative">
              <div className="flex gap-1 mb-4 text-brand-yellow">
                {[...Array(5)].map((_, i) => (
                  <SafeIcon key={i} icon={FiStar} className="fill-current" />
                ))}
              </div>
              <p className="text-gray-300 mb-6 leading-relaxed">"{t.text}"</p>
              <div className="border-t border-white/10 pt-4">
                <p className="text-white font-bold">{t.author}</p>
                <p className="text-xs text-brand-yellow uppercase tracking-wider">{t.role}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-500 text-sm">
            Join a growing community of people choosing clarity over conflict.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;